import Navbar from "./Navbar";
import React, { useState, useEffect, useRef } from "react";
import { classNames } from "primereact/utils";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Toolbar } from "primereact/toolbar";
import { InputTextarea } from "primereact/inputtextarea";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import axios from "../api/axios";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import { Dropdown } from "primereact/dropdown";

function TablaEmpresas({ Auth }) {
  let emptyEmpresa = {
    _id: null,
    numero: 0,
    razonSocial: "",
    rfc: "",
  };
  const [resultados, setEmpresas] = useState(null);
  const [selectedResultados, setSelectedEmpresas] = useState(null);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [opciones, setOpciones] = useState([]);
  const [selectedEmpresa, setSeleccionado] = useState(null);
  const toast = useRef(null);
  const dt = useRef(null);
  const axiosPrivate = useAxiosPrivate();
  useEffect(() => {
    if (opciones.length > 0) {
      console.table(opciones);
    }
  }, [opciones]);
  const showMessage = (tipo, titulo, msg) => {
    toast.current.show({ severity: tipo, summary: titulo, detail: msg });
  };
  const onSelect = async (event) => {
    try {
      console.log(event);
      const response = await axios.get("SUA/resultData", {
        params: { rfc: event },
      });

      if (response.status === 200) {
        const data = response.data;
        console.log(data);
        setEmpresas(data.datos);
      }
    } catch (error) {
      console.error("Error al obtener datos:", error);
      showMessage("error", "Error", error.error);
    } finally {
    }
  };

  useEffect(() => {
    const fetchDatos = async () => {
      try {
        console.log(Auth);
        const datosTransformados = Auth.Empresas.map((item) => ({
          label: item.nombre,
          value: item.rfc,
        }));
        setOpciones(datosTransformados);
      } catch (error) {
        console.error("Error al obtener datos:", error);
      }
    };

    fetchDatos();
  }, []);

  const seeRow = (product) => {
    console.log(product);
    let baseURL = window.location.origin;
    console.log(baseURL);
    baseURL = baseURL.replace("3000", "3500").replace("sua.", "api.");
    const url = `${baseURL}/SUA/resultExcel?year=${product.año}&bimestre=${product.bimestre}&rfc=${product.rfc}`;
    window.open(url, "_blank");
  };

  const exportCSV = () => {
    dt.current.exportCSV();
  };

  const leftToolbarTemplate = () => {
    return (
      <div className="flex flex-wrap gap-2">
        <div className="flex flex-column gap-2 mr-2">
          <Dropdown
            id="empresa"
            value={selectedEmpresa}
            options={opciones}
            onChange={(e) => {
              // console.log(JSON.stringify(opciones)); // el evento
              // console.log("objeto completo:", e.value); // el objeto
              // console.log("RFC:", e.value.value); // el RFC
              // console.log("Nombre:", e.value.label); // el nombre
              setSeleccionado(e.value); // guarda el objeto
              onSelect(e.value); // envía el objeto
            }}
            optionLabel="label"
            placeholder="Seleccione la empresa"
            className="w-full md:w-20rem"
          />
        </div>
      </div>
    );
  };

  const rightToolbarTemplate = () => {
    return (
      <Button
        label="Export"
        icon="pi pi-upload"
        className="p-button-help"
        onClick={exportCSV}
      />
    );
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-eye"
          rounded
          outlined
          className="mr-2"
          onClick={() => seeRow(rowData)}
        />
      </React.Fragment>
    );
  };

  const header = (
    <div className="flex flex-wrap gap-2 align-items-center justify-content-between">
      <h4 className="m-0"> </h4>
      <IconField iconPosition="left">
        <InputIcon className="pi pi-search" />
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Busqueda..."
        />
      </IconField>
    </div>
  );
  //   const productDialogFooter = (
  //     <React.Fragment>
  //       <Button label="Cancel" icon="pi pi-times" outlined onClick={hideDialog} />
  //       <Button label="Save" icon="pi pi-check" onClick={saveProduct} />
  //     </React.Fragment>
  //   );

  return (
    <div>
      <h1>Resultados</h1>
      <Toast ref={toast} />
      <div className="card">
        <Toolbar
          className="mb-4"
          left={leftToolbarTemplate}
          right={rightToolbarTemplate}
        ></Toolbar>
        <DataTable
          ref={dt}
          value={resultados}
          selection={selectedResultados}
          onSelectionChange={(e) => setSelectedEmpresas(e.value)}
          dataKey="_id"
          paginator
          rows={10}
          selectionMode="single"
          rowsPerPageOptions={[10, 20, 50]}
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          currentPageReportTemplate="Mostrando {first} de {last} de {totalRecords} registros"
          globalFilter={globalFilter}
          header={header}
          // stripedRows
        >
          <Column
            field="rfc"
            header="RFC"
            sortable
            style={{ minWidth: "12rem" }}
          ></Column>
          <Column
            field="año"
            header="Año"
            sortable
            style={{ minWidth: "16rem" }}
          ></Column>
          <Column
            field="bimestre"
            header="Bimestre"
            sortable
            style={{ minWidth: "10rem" }}
          ></Column>
          <Column
            field="updated_at"
            header="Fecha de creacion"
            sortable
            style={{ minWidth: "10rem" }}
          ></Column>
          <Column
            body={actionBodyTemplate}
            exportable={false}
            style={{ minWidth: "12rem" }}
          ></Column>
        </DataTable>
      </div>
    </div>
  );
}

// const ResultadosConfronta = () => {

//   return (
//     <>
//       {/* <Navbar Authentication={Authentication} /> */}
//       <h1>Resultados</h1>
//       <TablaEmpresas />
//     </>
//   );
// };
// const Container = styled.div`
//   /* height:100vh;*/
//   width: 100vh;
// `;

export default TablaEmpresas;
